import type { CustomBlockProps, RelatedFieldObject } from 'common/models';
import { useCustomTranslation } from 'helpers/translationHelper';
import React from 'react';

import CustomerBlock from './CustomerBlock';

interface Props {
  object: RelatedFieldObject;
  blockProps: CustomBlockProps;
}

const CustomerBlockWrapper: React.FC<Props> = (props): React.ReactElement => {
  const { object, blockProps } = props;

  const { t } = useCustomTranslation();

  const customerContent = object?.invoiceCustomer
    ? {
        address: object.invoiceCustomer.invoiceAddress,
        name: object.invoiceCustomer.name,
        identificationNumber: object.invoiceCustomer.identificationNumber,
        taxNumber: object.invoiceCustomer.taxNumber
      }
    : {
        address: object.customer!.invoiceAddress,
        name: object.customer!.name,
        taxNumber: object.customer!.taxNumber,
        identificationNumber: object.customer!.identificationNumber
      };

  if (blockProps.blockType === 'Customer' && blockProps.showInvoiceCustomerOnly) {
    if (object.invoiceCustomer) {
      return (
        <CustomerBlock
          customer={{
            address: object.invoiceCustomer.invoiceAddress,
            name: object.invoiceCustomer.name,
            identificationNumber: object.invoiceCustomer.identificationNumber,
            taxNumber: object.invoiceCustomer.taxNumber
          }}
          title={blockProps.customTitle || t('customData.invoiceCustomerHeader')}
          withTitle={blockProps.withTitle}
        />
      );
    }

    return <div />;
  }

  if (blockProps.blockType === 'Customer' && blockProps.showEndCustomerOnly) {
    return (
      <CustomerBlock
        customer={
          blockProps.customContent
            ? blockProps.customContent
            : {
                address: object.customer!.invoiceAddress,
                name: object.customer!.name,
                taxNumber: object.customer!.taxNumber,
                identificationNumber: object.customer!.identificationNumber
              }
        }
        title={blockProps.customTitle || t('customData.customerHeader')}
        withTitle={blockProps.withTitle}
      />
    );
  }

  return (
    <CustomerBlock
      customer={blockProps.customContent ? blockProps.customContent : customerContent}
      title={blockProps.customTitle || t('customData.customerHeader')}
      withTitle={blockProps.withTitle}
    />
  );
};

export default CustomerBlockWrapper;
